var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenDetail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7802 11.2801C15.9209 11.4206 16 11.6113 16.0002 11.8101V12.1901C15.9979 12.3885 15.919 12.5784 15.7802 12.7201L10.6402 17.8501C10.5463 17.9448 10.4185 17.998 10.2852 17.998C10.1518 17.998 10.024 17.9448 9.93016 17.8501L9.22016 17.1401C9.1261 17.0479 9.07309 16.9218 9.07309 16.7901C9.07309 16.6584 9.1261 16.5323 9.22016 16.4401L13.6702 12.0001L9.22016 7.5601C9.12551 7.46621 9.07227 7.33842 9.07227 7.2051C9.07227 7.07178 9.12551 6.94398 9.22016 6.8501L9.93016 6.1501C10.024 6.05544 10.1518 6.0022 10.2852 6.0022C10.4185 6.0022 10.5463 6.05544 10.6402 6.1501L15.7802 11.2801Z",
    fill: "#111D43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#111D43"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDetail);
export default __webpack_public_path__ + "static/media/openDetail.738874c83120901246e078d592038840.svg";
export { ForwardRef as ReactComponent };